var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3206 15.0328C1.15233 15.0323 0.987029 14.9696 0.84097 14.8508C0.512078 14.5858 0.307617 14.0714 0.307617 13.513V2.21221C0.307617 1.65224 0.512078 1.13942 0.84097 0.874433C0.990507 0.752243 1.16038 0.689406 1.33284 0.692491C1.5053 0.695576 1.67402 0.764469 1.82134 0.891969L8.61433 6.6733C8.7559 6.79951 8.87261 6.97478 8.95351 7.18267C9.03441 7.39055 9.07685 7.62424 9.07685 7.86183C9.07685 8.09941 9.03441 8.33311 8.95351 8.54099C8.87261 8.74888 8.7559 8.92415 8.61433 9.05036L1.82025 14.8332C1.66948 14.9628 1.49679 15.0318 1.3206 15.0328Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayButton);
export default __webpack_public_path__ + "static/media/videoPlayButton.d494aa6ec189239b4105f00c6b6cccd1.svg";
export { ForwardRef as ReactComponent };